export default __webpack_public_path__ + "static/media/img_parcours_mer_logo.ceecd4bc.svg";